import dynamic from 'next/dynamic';
import React from 'react';
const OnboardingScreen = dynamic(
  () => import('@/components/panels/onboarding/Onboarding'),
  {
    ssr: false,
  }
);

const Onboarding = () => {
  return <OnboardingScreen />;
};

export default Onboarding;
